import React from 'react';
import { Button, Grid, Typography } from '@mui/material';

function EmployeeInformation({
    data
}) {

    React.useEffect(() => {
        window.addEventListener('resize', data.atualizarTamanhoDaTela);
        data.atualizarTamanhoDaTela();
        return () => {
            window.removeEventListener('resize', data.atualizarTamanhoDaTela);
        };
    }, []);

    let standardTime = JSON.stringify(data.schedule['Segunda']);
    let differentDays = [];
    let flexSchedule = "[\"00:00\",\"00:00\",\"00:00\",\"00:00\",\"00:00h\"]"

    const isHoraryFlex = flexSchedule == standardTime

    for (let day in data.schedule) {
        if (JSON.stringify(data.schedule[day]) !== standardTime && day !== 'name') {
            differentDays.push(day);
        }
    }
    const firstElement = data.scheduleDays[0];
    const lastElement = differentDays.length > 0 ? data.scheduleDays[data.scheduleDays.length - 2] : data.scheduleDays[data.scheduleDays.length - 1];

    return (
        <Grid style={{ width: data.larguraDaTela > 1500 ? '35%' : '30%' }}>
            <Typography style={data.larguraDaTela > 1500 ? styles.Title : styles.TitleLargura}>
                Colaborador:
            </Typography>
            <Grid style={{ padding: '10px 0px 10px 0px' }}>
                <Typography style={data.larguraDaTela > 1500 ? styles.NameEmployee : styles.NameEmployeeLargura}>
                    {data.employeeDataFilter.length > 0 ? data.employeeSelected ? data.employeeSelected : data.employeeDataFilter[0].name : data.employeeSelected}
                </Typography>
            </Grid>
            {
                standardTime ?
                    <>
                        <Typography style={data.larguraDaTela > 1500 ? styles.WorkingDayTitle : styles.WorkingDayTitleLargura}>
                            Jornada de trabalho:
                        </Typography>
                        <Typography style={data.larguraDaTela > 1500 ? styles.WorkingDayDays : styles.WorkingDayDaysLargura}>
                            {data.schedule.name}
                        </Typography>
                        <Grid style={{ display: 'flex' }}>
                            <Typography style={data.larguraDaTela > 1500 ? styles.WorkingDayDays : styles.WorkingDayDaysLargura}>
                                De {firstElement} à {lastElement}:
                            </Typography>
                            {isHoraryFlex ?
                                <Typography style={data.larguraDaTela > 1500 ? styles.Journey : styles.JourneyLargura}>
                                    Horário flexivel
                                </Typography>
                                :
                                <Typography style={data.larguraDaTela > 1500 ? styles.Journey : styles.JourneyLargura}>
                                    {data.schedule['Segunda'][0]} - {data.schedule['Segunda'][1]} | {data.schedule['Segunda'][2]} - {data.schedule['Segunda'][3]}
                                </Typography>
                            }
                        </Grid>
                        <Typography style={data.larguraDaTela > 1500 ? styles.workload : styles.workloadLargura}>
                            Carga horária: {data.schedule['Segunda'][4]}
                        </Typography>
                        {
                            differentDays.length > 0 ?
                                <Grid style={{ display: 'flex' }}>
                                    <Typography style={data.larguraDaTela > 1500 ? styles.WorkingDayDays : styles.WorkingDayDaysLargura}>
                                        {differentDays[differentDays.length - 1]}:
                                    </Typography>
                                    <Typography style={data.larguraDaTela > 1500 ? styles.Journey : styles.JourneyLargura}>
                                        {data.schedule[differentDays[differentDays.length - 1]][0] + ' ' + '-' + ' ' + data.schedule[differentDays[differentDays.length - 1]][1]}
                                        {data.schedule[differentDays[differentDays.length - 1]][2] ? ' ' + '|' + ' ' : null}
                                        {data.schedule[differentDays[differentDays.length - 1]][2] ? data.schedule[differentDays[differentDays.length - 1]][2] + '-' : null}
                                        {data.schedule[differentDays[differentDays.length - 1]][3] ? data.schedule[differentDays[differentDays.length - 1]][3] : null}- CH: {data.schedule[differentDays[differentDays.length - 1]][4]}
                                    </Typography>

                                </Grid>
                                :
                                null

                        }


                    </>
                    :
                    <Typography>
                        <Typography style={data.larguraDaTela > 1500 ? styles.WorkingDayTitle : styles.WorkingDayTitleLargura}>
                            Jornada de trabalho:
                        </Typography>
                        <Typography style={data.larguraDaTela > 1500 ? styles.WorkingDayDays : styles.WorkingDayDaysLargura}>
                            {data.schedule.name}
                        </Typography>
                        {
                            differentDays.length > 0 ?
                                <Grid style={{ display: 'flex' }}>
                                    <Typography style={data.larguraDaTela > 1500 ? styles.WorkingDayDays : styles.WorkingDayDaysLargura}>
                                        {differentDays[differentDays.length - 1] == 'rotation' ? 'Rotativa' : null}:
                                    </Typography>
                                    <Typography style={data.larguraDaTela > 1500 ? styles.Journey : styles.JourneyLargura}>
                                        {data.schedule[differentDays[differentDays.length - 1]][0] + ' ' + '-' + ' ' + data.schedule[differentDays[differentDays.length - 1]][1]}
                                        {data.schedule[differentDays[differentDays.length - 1]][2] ? ' ' + '|' + ' ' : null}
                                        {data.schedule[differentDays[differentDays.length - 1]][2] ? data.schedule[differentDays[differentDays.length - 1]][2] + '-' : null}
                                        {data.schedule[differentDays[differentDays.length - 1]][3] ? data.schedule[differentDays[differentDays.length - 1]][3] : null}- CH: {data.schedule[differentDays[differentDays.length - 1]][4]}
                                    </Typography>

                                </Grid>
                                :
                                null

                        }</Typography>
            }

            <Grid style={styles.GridButtons}>
                <Button style={styles.Button} onClick={data.handlePrevious}>
                    anterior
                </Button>
                <Button style={styles.Button} onClick={data.handleNext}>
                    próximo
                </Button>
            </Grid>
        </Grid>
    )
}

export default EmployeeInformation;

const styles = ({
    TitleLargura: {
        color: '#537ccd',
        fontSize: '15px',
        fontWeight: 'bold',
        fontFamily: 'Montserrat'
    },
    Title: {
        color: '#537ccd',
        fontSize: '18px',
        fontWeight: 'bold',
        fontFamily: 'Montserrat'
    },
    NameEmployee: {
        color: '#464a54',
        fontSize: '30px',
        fontWeight: 'bold',
        lineHeight: '30px',
        fontFamily: 'Montserrat'
    },
    NameEmployeeLargura: {
        color: '#464a54',
        fontSize: '20px',
        fontWeight: 'bold',
        lineHeight: '30px',
        fontFamily: 'Montserrat'
    },
    WorkingDayTitleLargura: {
        color: '#464a54',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
        fontSize: '11px'
    },
    WorkingDayTitle: {
        color: '#464a54',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
    },
    WorkingDayDaysLargura: {
        color: '#464a54',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
        fontSize: '11px'
    },
    WorkingDayDays: {
        color: '#464a54',
        fontWeight: 'bold',
        fontFamily: 'Montserrat'
    },
    JourneyLargura: {
        paddingLeft: '10px',
        fontSize: '11px',
        alignItems: 'center',
        display: 'flex',
        fontFamily: 'Montserrat',
        fontWeight: 'bold'
    },
    Journey: {
        paddingLeft: '10px',
        fontSize: '15px',
        alignItems: 'center',
        display: 'flex',
        fontFamily: 'Montserrat',
        fontWeight: 'bold'
    },
    workloadLargura: {
        fontSize: '11px',
        fontFamily: 'Montserrat',
        fontWeight: 'bold'
    },
    workload: {
        fontFamily: 'Montserrat',
        fontWeight: 'bold'
    },
    GridButtons: {
        width: '200px',
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: '34px'
    },
    Button: {
        color: '#FFF',
        padding: '10px',
        borderRadius: '15px',
        fontFamily: 'Montserrat',
        backgroundColor: '#537ccd'
    }
})